import { getFileBlob } from "utils"

export const mapClientFormToApi = (data = {}) => ({
  name: data?.clientName,
  email: data?.clientContactEmail,
  first_name: data?.contactFirstName,
  last_name: data?.contactLastName,
  has_own_app: data?.hasOwnApp || false,
  url: data?.clientSiteURL,
  contact_phone: data?.phone,
  contact_mobile: data?.mobile,
  contact_address: data?.address,
  start_date: data?.startDate ? new Date(data?.startDate) : null,
  logo: getFileBlob(data?.logoImage?.editedImage),
  key_id: data?.keyID,
  team_id: data?.teamID,
  bundle_id: data?.bundleID,
  p8_certificate_file: getFileBlob(data?.p8Certificate?.dataURI),
  p8_certificate_name: data?.p8Certificate?.name,
  api_token: data?.api_token,
  vendor_id: data?.vendor_id,
})

export const mapClientSuccessManagerToApi = (data = {}) => ({
  email: data?.clientSuccessManagerEmail,
  name: data?.clientSuccessManagerName,
  phone: data?.clientSuccessManagerPhone,
  vendor_id: data?.vendor_id,
})

const formatDate = date => {
  const d = new Date(date)
  let month = "" + (d.getMonth() + 1)
  let day = "" + d.getDate()
  const year = d.getFullYear()

  if (month.length < 2) {
    month = "0" + month
  }
  if (day.length < 2) {
    day = "0" + day
  }

  return [year, month, day].join("-")
}

export const mapApiToClientForm = (
  clientResponse = {},
  clientSuccessManagerResponse = {}
) => {
  const client = {
    clientName: clientResponse?.name,
    clientContactEmail: clientResponse?.email,
    contactFirstName: clientResponse?.first_name,
    contactLastName: clientResponse?.last_name,
    hasOwnApp: clientResponse?.has_own_app,
    clientSiteURL: clientResponse?.url,
    phone: clientResponse?.contact_phone,
    mobile: clientResponse?.contact_mobile,
    address: clientResponse?.contact_address,
    startDate:
      clientResponse?.start_date && formatDate(clientResponse?.start_date),
    logoImage: { editedImage: clientResponse?.logo },
    keyID: clientResponse?.key_id,
    teamID: clientResponse?.team_id,
    bundleID: clientResponse?.bundle_id,
    p8Certificate: {
      name: clientResponse?.p8_certificate_name,
      dataURI: clientResponse?.p8_certificate_name,
    },
  }
  let clientContactManager = {}
  if (Object.keys(clientSuccessManagerResponse).length) {
    clientContactManager = {
      clientSuccessManagerEmail: clientSuccessManagerResponse?.email,
      clientSuccessManagerName: clientSuccessManagerResponse?.name,
      clientSuccessManagerPhone: clientSuccessManagerResponse?.phone,
    }
  }
  return { ...client, ...clientContactManager }
}

export const mapUpdatedClientToApi = (data = {}) => ({
  name: data?.clientName,
  email: data?.clientContactEmail,
  first_name: data?.contactFirstName,
  last_name: data?.contactLastName,
  has_own_app: data?.hasOwnApp || false,
  url: data?.clientSiteURL,
  contact_phone: data?.phone,
  contact_mobile: data?.mobile,
  contact_address: data?.address,
  start_date: data?.startDate ? new Date(data?.startDate) : null,
  logo: getFileBlob(data?.logoImage?.editedImage),
  key_id: data?.keyID,
  team_id: data?.teamID,
  bundle_id: data?.bundleID,
  p8_certificate_file:
    data?.p8Certificate?.dataURI &&
    data?.p8Certificate?.dataURI.startsWith("data:")
      ? getFileBlob(data?.p8Certificate?.dataURI)
      : null,
  p8_certificate_name: data?.p8Certificate?.name,
  api_token: data?.api_token,
  vendor_id: data?.vendor_id,
  delete_file: data?.deleteLogo || 0,
  delete_p8_certificate_file: data?.deleteCertificate || 0,
})

const convertAPIBool = apiBoolValue => {
  return apiBoolValue == 1 ? true : false
}

const convertBool = boolValue => {
  return boolValue == "true" || boolValue == 1 || boolValue == true ? 1 : 0
}

export const mapApiToSettingsForm = (apiResponse = {}) => ({
  newAccountText: apiResponse?.create_account_text,
  adsEnabled: convertAPIBool(apiResponse?.ads_enabled),
  logInButtonText: apiResponse?.log_in_button,
  imageStyle: JSON.stringify(apiResponse?.styles, null, 2),
  restrictedAccessMessage: apiResponse?.restricted_visitors_access_message,
  appDisabledText: apiResponse?.app_disabled_text,
  appEnabled: convertAPIBool(apiResponse?.app_enabled),
  appNotificationsEnabled: convertAPIBool(
    apiResponse?.app_notifications_enabled
  ),
  associationClient: convertAPIBool(apiResponse?.association_client),
  appUserList: convertAPIBool(apiResponse?.app_user_list),
  displayDashboard: convertAPIBool(apiResponse?.dashboard),
  appWidePrivateMessage: convertAPIBool(apiResponse?.app_wide_private_message),
  chatWithContactsOnly: convertAPIBool(apiResponse?.chat_with_contacts_only),
  contactUs: convertAPIBool(apiResponse?.contact_us),
  categorizeExp: convertAPIBool(apiResponse?.categorize_experiences),
  buVisibleToAll: convertAPIBool(apiResponse?.bu_experience),
  forcedUpdateEnabled: convertAPIBool(apiResponse?.forced_update_enabled),
  exploreTheAppScreen: convertAPIBool(apiResponse?.no_register_content),
  disableLogIns: convertAPIBool(apiResponse?.log_in_disabled),
  socialProfile: convertAPIBool(apiResponse?.social_profile),
  visitorStatus: convertAPIBool(apiResponse?.unregistered_user_access),
  axisCareEnabled: convertAPIBool(apiResponse?.axis_care_integration_enabled),
  skipLandingScreen: convertAPIBool(
    apiResponse?.skip_landing_page_if_logged_in
  ),
  searchField: convertAPIBool(apiResponse?.event_search_field),
  qrCode: convertAPIBool(apiResponse?.qr_text_code),
  locationServices: convertAPIBool(apiResponse?.location_services),
  landingPage: convertAPIBool(apiResponse?.landing_page),
  deleteAccText: apiResponse?.delete_account_text,
  googleMapsKey: apiResponse?.google_maps_key,
  temporaryPwd: apiResponse?.temporary_password_string,
  productsAndSubscriptions: convertAPIBool(
    apiResponse?.products_orders_enabled
  ),
  pendingUsersDP: convertAPIBool(apiResponse?.show_pending_users_in_dp),
  newsFeed: convertAPIBool(apiResponse?.news_feed_enabled),
  communicationHyperlinks: convertAPIBool(
    apiResponse?.communication_hyperlinks
  ),
  nfcHyperlink: convertAPIBool(apiResponse?.nfc_hyperlinks),
  sendFeatureFilledOutEmail: convertAPIBool(
    !apiResponse?.do_not_send_feature_filled_out_email_to_sender
  ),
  confirmEmail: convertAPIBool(apiResponse?.confirm_email_on_sign_up),
  allowDm: convertAPIBool(apiResponse?.app_user_list_allow_dms),
  includeExperienceDm: convertAPIBool(
    apiResponse?.app_wide_private_message_include_experience_dm
  ),
  webInboxEnabled: convertAPIBool(apiResponse?.web_inbox_enabled),
  ecommerce_enabled: convertAPIBool(apiResponse?.ecommerce_enabled),
  booking_payments_enabled: convertAPIBool(
    apiResponse?.booking_payments_enabled
  ),
  payment_application_fee: apiResponse?.payment_application_fee,
  payment_commission: apiResponse?.payment_commission,
  subscription_application_fee_percentage:
    apiResponse?.subscription_application_fee_percentage,
  ticket_application_fee: apiResponse?.ticket_application_fee,
  ticket_application_fee_percentage:
    apiResponse?.ticket_application_fee_percentage,
})

export const mapFeaturesSetupToApi = (featuresList = [], formValues = {}) => {
  const updatedFeatures = featuresList.map(feature => ({
    ...feature,
    status: formValues[`${feature.machine_name}`],
  }))
  return updatedFeatures
}

const parseJSON = text => {
  try {
    return JSON.parse(text)
  } catch (error) {
    return null
  }
}

export const mapSettingsFormToApi = (data = {}, currentValues = {}) => ({
  ads_enabled: convertBool(data?.adsEnabled),
  app_disabled_text: data?.appDisabledText,
  app_enabled: convertBool(data?.appEnabled),
  app_notifications_enabled: convertBool(data?.appNotificationsEnabled),
  app_user_list: convertBool(data?.appUserList),
  app_wide_private_message: convertBool(data?.appWidePrivateMessage),
  axis_care_integration_enabled: convertBool(data?.axisCareEnabled),
  association_client: convertBool(data?.associationClient),
  bu_experience: convertBool(data?.buVisibleToAll),
  categorize_experiences: convertBool(data?.categorizeExp),
  chat_with_contacts_only: convertBool(data?.chatWithContactsOnly),
  contact_us: convertBool(data?.contactUs),
  create_account_text: data?.newAccountText,
  dashboard: convertBool(data?.displayDashboard),
  event_search_field: convertBool(data?.searchField),
  forced_update_enabled: convertBool(data?.forcedUpdateEnabled),
  landing_page: convertBool(data?.landingPage),
  location_services: convertBool(data?.locationServices),
  log_in_button: data?.logInButtonText,
  log_in_disabled: convertBool(data?.disableLogIns),
  no_register_content: convertBool(data?.exploreTheAppScreen),
  qr_text_code: convertBool(data?.qrCode),
  restricted_visitors_access_message: data?.restrictedAccessMessage,
  skip_landing_page_if_logged_in: convertBool(data?.skipLandingScreen),
  social_profile: convertBool(data?.socialProfile),
  styles: parseJSON(data?.imageStyle) || currentValues.styles,
  unregistered_user_access: convertBool(data?.visitorStatus),
  delete_account_text: data?.deleteAccText,
  google_maps_key: data?.googleMapsKey,
  temporary_password_string: data?.temporaryPwd,
  products_orders_enabled: convertBool(data?.productsAndSubscriptions),
  show_pending_users_in_dp: convertBool(data?.pendingUsersDP),
  news_feed_enabled: convertBool(data?.newsFeed),
  communication_hyperlinks: convertBool(data?.communicationHyperlinks),
  nfc_hyperlinks: convertBool(data?.nfcHyperlink),
  do_not_send_feature_filled_out_email_to_sender: convertBool(
    !data?.sendFeatureFilledOutEmail
  ),
  confirm_email_on_sign_up: convertBool(data?.confirmEmail),
  app_user_list_allow_dms: convertBool(data?.allowDm),
  app_wide_private_message_include_experience_dm: convertBool(
    data?.includeExperienceDm
  ),
  web_inbox_enabled: convertBool(data?.webInboxEnabled),
  ecommerce_enabled: convertBool(data?.ecommerce_enabled),
  booking_payments_enabled: convertBool(data?.booking_payments_enabled),
  payment_application_fee: data?.payment_application_fee,
  payment_commission: data?.payment_commission,
  subscription_application_fee_percentage:
    data?.subscription_application_fee_percentage,
  ticket_application_fee: data?.ticket_application_fee,
  ticket_application_fee_percentage: data?.ticket_application_fee_percentage,
})

export const fieldLevelValidation = value =>
  !value || value.trim().length === 0 ? "Required" : undefined

export const emailVaildation = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? "Invalid email address"
    : undefined

export const mapApiToEmailSettings = (apiResponse = {}) => ({
  logoImage: { editedImage: apiResponse?.logo },
  appName: apiResponse?.app_name,
  color: apiResponse?.color,
  appStoreURL: apiResponse?.apple_store_url,
  googleStoreURL: apiResponse?.google_store_url,
  fromName: apiResponse?.template_from_name,
  fromEmail: apiResponse?.template_from_email,
  appInvite: apiResponse?.template_temporary_password,
  booking: apiResponse?.template_booking,
  bookingPayment: apiResponse?.template_booking_payment,
  customEmail: apiResponse?.template_custom_email,
  experienceInvite: apiResponse?.template_guest_invite,
  experienceReminder: apiResponse?.template_event_reminder,
  formBuilderPayment: apiResponse?.template_form_builder_payment,
  orderPayment: apiResponse?.template_order_payment,
  referFriend: apiResponse?.template_refer_friend,
  referrer: apiResponse?.template_referrer,
  rsvp: apiResponse?.template_rsvp,
  visitorRegistered: apiResponse?.template_visitor,
  visitorRegisteredTentant: apiResponse?.template_visitor_tenant,
  welcomeUser: apiResponse?.template_welcome_user,
  surveyFormBuilder: apiResponse?.template_filled_out_feature,
  contactUsEmail: apiResponse?.contact_us_email,
  appleStoreDevAcc: apiResponse?.apple_developer_name,
  googleStoreDevAcc: apiResponse?.google_developer_name,
})

export const mapEmailSettingsToApi = (data = {}) => {
  const emailConfig = {
    vendor_id: data?.vendor_id,
    api_token: data?.api_token,
    delete_logo: data?.deleteImage ? data?.deleteImage : 0,
    apple_store_url: data?.appStoreURL,
    google_store_url: data?.googleStoreURL,
    app_name: data?.appName,
    color: data?.color,
    logo: getFileBlob(data?.logoImage?.editedImage),
    contact_us_email: data?.contactUsEmail,
    apple_developer_name: data?.appleStoreDevAcc,
    google_developer_name: data?.googleStoreDevAcc,
  }

  const config = {
    template_booking: data?.booking,
    template_booking_payment: data?.bookingPayment,
    template_custom_email: data?.customEmail,
    template_event_reminder: data?.experienceReminder,
    template_filled_out_feature: data?.surveyFormBuilder,
    template_form_builder_payment: data?.formBuilderPayment,
    template_from_email: data?.fromEmail,
    template_from_name: data?.fromName,
    template_guest_invite: data?.experienceInvite,
    template_order_payment: data?.orderPayment,
    template_refer_friend: data?.referFriend,
    template_referrer: data?.referrer,
    template_rsvp: data?.rsvp,
    template_temporary_password: data?.appInvite,
    template_visitor: data?.visitorRegistered,
    template_visitor_tenant: data?.visitorRegisteredTentant,
    template_welcome_user: data?.welcomeUser,
  }
  return [emailConfig, config]
}

export const mapApiToPaymentSettings = (apiResponse = {}) => ({
  eCommerce: convertAPIBool(apiResponse?.ecommerce_enabled),
  enableBookingPayments: convertAPIBool(apiResponse?.booking_payments_enabled),
  bookingPercentage: apiResponse?.bookings_percentage,
  bookingFee: apiResponse?.bookings_fee,
  formBuilderPercentage: apiResponse?.form_builders_percentage,
  formBuilderFee: apiResponse?.form_builders_fee,
  productsPercentage: apiResponse?.products_percentage,
  productsFee: apiResponse?.products_fee,
})

export const minValueValidation = value =>
  value && value < 0 ? `The value must be a positive number` : undefined

export const maxValueValidation = value =>
  value && value > 100 ? `The commission must be under 100` : undefined
